// Facet classification for the `initialResults` hydration (see getInitialResults in
// ./search.js). InstantSearch rebuilds SearchResults from these, so each facet must land in
// the same bucket its widget uses (disjunctive / conjunctive / hierarchical) or its data is
// dropped and the widget renders empty.
//
// Single source of truth for that classification — keep in sync with filterWidgets.js,
// recommendedFilterWidgets.js and configure() in search.js.
// Declaring a facet here is what lets a URL parameter become a refinement. It does NOT mean the
// server-side query asks for its counts: Search::Facets splits these into WIDGET_COUNTS (requested,
// because a widget renders the counts) and REFINEMENT_ONLY (not requested — nothing displays them).
// Adding a facet here that a widget renders means adding it to WIDGET_COUNTS too, or the hydrated
// first paint shows that filter empty. spec/services/search/facets_spec.rb enforces the pairing.

// Everything OR-refinable on a PLP: refinementList(operator:'or') + toggleRefinement +
// rangeInput/numericMenu + user_slug/_tags lists + configure()'s disjunctiveFacets.
export const DISJUNCTIVE_FACETS = [
  // refinementList (operator: 'or')
  'designed_by_name',
  'year_of_manufacture',
  'brand_name',
  'age_group_name',
  'vibe_names',
  'color_name',
  'main_material_name',
  'country_from_address',
  'address_city',
  'number_of_doors',
  'number_of_drawers',
  'number_of_shelves',
  'number_of_seats',
  'feature_names',
  'seating_shape_names',
  'door_type_name',
  'shape_name',
  'orientation_name',
  'art_size_name',
  'art_subject_names',
  'artistic_movement_names',
  'set_of',
  // toggleRefinement (each renders a single-value disjunctive facet)
  'free_london_delivery_for_algolia',
  'free_uk_delivery_for_algolia',
  'free_collection',
  'top_score_seller',
  'professional_seller',
  'trade_price_and_trade_price_under_sale_price',
  'sale',
  'professionally_reupholstered',
  'reupholstery_available',
  'professionally_refurbished',
  'professionally_cleaned',
  'certificate_of_authenticity',
  'signed_by_artist',
  'sustainable_packaging',
  'in_time_for_christmas_for_algolia',
  // rangeInput / customPriceRangeWidget / numericMenu (need facet stats)
  'width_float',
  'height_float',
  'depth_float',
  'display_price_for_algolia',
  'display_price_trade_user_for_algolia',
  'sale_percentage_int',
  // refinement lists wired up directly in search.js
  'user_slug',
  '_tags',
  // categoryTreeFilter.js — an unrefined declared facet is inert when the flag is off
  'category_paths',
  // configure() disjunctiveFacets in search.js
  'most_specific_category_name',
  'published_recently',
  'commercially_accessible',
  'luxury_items'
]

// configure()'s `facets`. These four are also disjunctive facets — declared in both buckets,
// mirroring the live client's helper state.
export const CONJUNCTIVE_FACETS = [
  'sale',
  'published_recently',
  'commercially_accessible',
  'luxury_items'
]

// The single hierarchicalMenu on the PLP (category-hierarchy-filter).
export const HIERARCHICAL_FACETS = [
  {
    name: 'category_hierarchy.lvl0',
    attributes: [
      'category_hierarchy.lvl0',
      'category_hierarchy.lvl1',
      'category_hierarchy.lvl2',
      'category_hierarchy.lvl3'
    ],
    separator: ' > '
  }
]
